import styles from './stepper.module.scss';
import MaterialStepper from '@mui/material/Stepper';
import MaterialStep from '@mui/material/Step';
import MaterialStepLabel from '@mui/material/StepLabel';
import MaterialMobileStepper from '@mui/material/MobileStepper';
import MaterialStepButton from '@mui/material/StepButton';
import MaterialStepConnector from '@mui/material/StepConnector';
import MaterialStepContent from '@mui/material/StepContent';
import MaterialStepIcon from '@mui/material/StepIcon';
import { ReactNode } from 'react';

/* eslint-disable-next-line */
export interface StepperProps {
  activeStep?: number,
  alternativeLabel?: boolean,
  children: any,
  // classes?: object,
  // connector?: any,
  nonLinear?: boolean,
  orientation?: 'horizontal' | 'vertical',
  sx?: any,
  className?: string,
}

export interface StepProps {
  active?: boolean,
  children: any,
  // classes?: object,
  // completed?: boolean,
  disabled?: boolean,
  expanded?: boolean,
  index?: any,
  // last?: boolean,
  sx?: any
}

export interface StepLabelProps {
  children: any,
  // classes?: object,
  // componentsProps?: object,
  error?: boolean,
  icon?: ReactNode,
  // optional?: ReactNode,
  // StepIconComponent?: any,
  // StepIconProps?: object
  sx?: any
}

export interface MobileStepperProps {
  steps: number,
  activeStep?: number,
  backButton?: ReactNode,
  // classes?: object,
  // LinearProgressProps?: object,
  nextButton?: ReactNode,
  position?: 'bottom' | 'static' | 'top',
  sx?: any,
  variant?: 'dots' | 'progress' | 'text'
}

export interface StepButtonProps {
  children: any,
  color?: string
  onClick?: (...args: any[]) => void,
  // classes?: object,
  icon?: ReactNode,
  // optional?: ReactNode,
  sx?: any
}

export interface StepConnectorProps {
  // classes?: object,
  sx?: any
}

export interface StepContentProps {
  children: any,
  // classes?: object,
  sx?: any,
  // TransitionComponent?: any,
  // transitionDuration?: 'auto' | number | { appear?: number, enter?: number, exit?: number },
  // TransitionProps?: object
}

export interface StepIconProps {
  active?: boolean,
  // classes?: object,
  completed?: boolean,
  error?: boolean,
  icon: ReactNode,
  sx?: any
}

export function Stepper(props: StepperProps) {
  return (
    <MaterialStepper
      nonLinear={props.nonLinear}
      activeStep={props.activeStep}
      alternativeLabel={props.alternativeLabel}
      orientation={props.orientation}
      sx={props.sx}
      className={props.className}>
      {props.children}
    </MaterialStepper>
  );
}

export function Step(props: StepProps) {
  return (
    <MaterialStep
      active={props.active}
      index={props.index}
      disabled={props.disabled}
      expanded={props.expanded}
      sx={props.sx}>
      {props.children}
    </MaterialStep>
  );
}

export function StepLabel(props: StepLabelProps) {
  return (
    <MaterialStepLabel
      error={props.error}
      icon={props.icon}>
      {props.children}
    </MaterialStepLabel>
  );
}

export function MobileStepper(props: MobileStepperProps) {
  return (
    <MaterialMobileStepper
      backButton={props.backButton}
      nextButton={props.nextButton}
      steps={props.steps}
      variant={props.variant}
      activeStep={props.activeStep}
      position={props.position}
      sx={props.sx}
    />
  );
}

export function StepButton(props: StepButtonProps) {
  return (
    <MaterialStepButton
      icon={props.icon}
      color={props.color}
      onClick={props.onClick}
      sx={props.sx}>
      {props.children}
    </MaterialStepButton>
  );
}

export function StepConnector(props: StepConnectorProps) {
  return (
    <MaterialStepConnector
      sx={props.sx}
    />
  );
}

export function StepContent(props: StepContentProps) {
  return (
    <MaterialStepContent
      sx={props.sx}>
      {props.children}
    </MaterialStepContent>
  );
}

export function StepIcon(props: StepIconProps) {
  return (
    <MaterialStepIcon
      icon={props.icon}
      active={props.active}
      completed={props.completed}
      error={props.error}
      sx={props.sx}
    />
  );
}

export default Stepper;